export enum TimeclockScreenNames {
  MAIN = 'timeclock',
  TIMECLOCK_REPORT = 'timeclock_report',
}
